/**
 * Ole Surf — Brand Product Randomizer
 * 
 * Este script se encarga de reordenar de forma aleatoria (shuffle) los productos
 * de una colección cuando se visualiza una marca (como Vissla).
 * Soporta recargas automáticas por AJAX (filtros) y eventos del editor de Shopify.
 */

(function() {
  'use strict';

  // Configuración de selectores comunes en temas de Shopify (Dawn, Kalles, etc.)
  const CONFIG = {
    // Selectores del contenedor de productos
    gridSelectors: [
      '#product-grid',
      '.product-grid',
      '.grid--view-items',
      '.main-collection-product-grid',
      '.products.elements-grid',
      '[data-view="grid"]'
    ],
    // Selectores de los elementos de producto individuales
    itemSelectors: [
      '.grid__item',
      '.product-col',
      '.product-item',
      '.col-charcoal',
      '.product.col-3'
    ],
    // Habilitar depuración en consola
    debug: true
  };

  function log(...args) {
    if (CONFIG.debug) {
      console.log('[Ole Randomizer]', ...args);
    }
  }

  // Algoritmo Fisher-Yates para mezclar un array
  function shuffleArray(array) {
    let currentIndex = array.length, randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
    return array;
  }

  // Función principal para mezclar los productos en el DOM
  function randomizeGrid() {
    let grid = null;
    let items = [];

    // 1. Buscar el contenedor del grid
    for (let selector of CONFIG.gridSelectors) {
      grid = document.querySelector(selector);
      if (grid) {
        log(`Contenedor encontrado con selector: "${selector}"`);
        break;
      }
    }

    if (!grid) {
      log('No se encontró ningún contenedor de productos compatible.');
      return;
    }

    // 2. Buscar los items de producto dentro del contenedor
    for (let selector of CONFIG.itemSelectors) {
      items = Array.from(grid.querySelectorAll(selector));
      // Filtrar para asegurarse de que son hijos directos o correspondientes
      if (items.length > 0) {
        log(`${items.length} productos encontrados con selector: "${selector}"`);
        break;
      }
    }

    if (items.length === 0) {
      // Intento alternativo: obtener todos los hijos directos del grid
      items = Array.from(grid.children);
      log(`${items.length} productos obtenidos mediante hijos directos.`);
    }

    if (items.length <= 1) {
      log('No hay suficientes productos para ordenar de forma aleatoria.');
      return;
    }

    // Guardar el estado de foco activo antes de reorganizar el DOM si es necesario
    const activeElement = document.activeElement;

    // 3. Mezclar los elementos
    const shuffledItems = shuffleArray([...items]);

    // Ocultar temporalmente para evitar parpadeos visuales bruscos (opcional)
    grid.style.opacity = '0';

    // 4. Re-insertar los elementos ordenados en el DOM
    // Al usar appendChild en elementos existentes, se mueven de posición automáticamente
    const fragment = document.createDocumentFragment();
    shuffledItems.forEach(item => {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);

    // Restaurar opacidad con una transición suave
    setTimeout(() => {
      grid.style.transition = 'opacity 0.3s ease';
      grid.style.opacity = '1';
    }, 50);

    // Restaurar foco si se perdió
    if (activeElement && document.body.contains(activeElement)) {
      activeElement.focus();
    }

    log('Productos ordenados de forma aleatoria correctamente.');
  }

  // Verifica si el orden aleatorio debe aplicarse en la página actual
  function shouldRandomize() {
    const url = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);

    // Activar si hay un parámetro ?sort_by=random o ?random=true
    if (searchParams.get('sort_by') === 'random' || searchParams.get('random') === 'true') {
      return true;
    }

    // Comprobar si es una colección de marca o vendor específico
    // En Shopify las marcas suelen estar en /collections/vendors?q=Marca
    if (url.includes('/collections/vendors') && searchParams.get('q')) {
      return true;
    }

    // O si la URL contiene una colección específica que sea de una marca conocida.
    // Ejemplo: /collections/vissla, /collections/billabong, etc.
    const pathSegments = url.split('/');
    const collectionHandle = pathSegments[pathSegments.indexOf('collections') + 1];
    
    // Lista de marcas o patrones comunes que dispararán el orden aleatorio.
    // Puedes ampliar esta lista o añadir clases específicas en tu plantilla liquid.
    const brandCollections = ['vissla', 'rvca', 'quiksilver', 'roxy', 'rip-curl', 'patagonia', 'volcom', 'element', 'vans'];
    
    if (collectionHandle && brandCollections.includes(collectionHandle.toLowerCase())) {
      return true;
    }

    // Comprobar si existe un elemento con el atributo data-randomize-products
    if (document.querySelector('[data-randomize-products="true"]')) {
      return true;
    }

    return false;
  }

  // Inicialización
  function init() {
    if (shouldRandomize()) {
      log('Iniciando randomizador para esta vista...');
      randomizeGrid();

      // Observar cambios en el DOM para cuando se apliquen filtros por AJAX
      // Los filtros de Shopify normalmente vuelven a renderizar el contenedor del grid.
      observeAjaxFilters();
    } else {
      log('No se cumplen las condiciones para ordenar aleatoriamente.');
    }
  }

  // Observa si el contenedor del grid se recarga o muta debido a filtros AJAX
  let observer = null;
  function observeAjaxFilters() {
    if (observer) {
      observer.disconnect();
    }

    // Observar la sección principal de productos o el cuerpo
    const target = document.querySelector('#ProductGridContainer') || document.querySelector('.main-collection-product-grid') || document.body;
    
    if (!target) return;

    observer = new MutationObserver(function(mutations) {
      let shouldReRun = false;
      mutations.forEach(mutation => {
        // Si se han añadido nodos (ej. recarga por AJAX)
        if (mutation.addedNodes.length > 0) {
          shouldReRun = true;
        }
      });

      if (shouldReRun) {
        log('Se detectaron cambios en el DOM (filtro AJAX). Re-ejecutando mezcla...');
        // Desconectar temporalmente para evitar bucles infinitos durante la mezcla
        observer.disconnect();
        randomizeGrid();
        // Volver a escuchar después del reordenamiento
        setTimeout(observeAjaxFilters, 500);
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  // Ejecución en carga inicial del DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Soporte para recargas en el Editor de Temas de Shopify (Personalizador)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('#product-grid') || event.target.classList.contains('section')) {
      log('Sección cargada en el editor de Shopify. Re-mezclando...');
      init();
    }
  });

  // Exportar a nivel global por si se necesita ejecutar manualmente
  window.OleBrandRandomizer = {
    randomize: randomizeGrid,
    init: init
  };

})();
